// extracted by mini-css-extract-plugin
export default {"tableRow":"CtoJbGJS","tableContainer":"rmDlVEfh","arrowRight":"h0aSu2P4","show":"fObS1uns","isOnLessonStatisticPage":"qQwHFFnX"};
    if(module.hot) {
      // 1776432161760
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  